import i18n from 'i18next';
import React from 'react';
import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import useStyles from './IRTHConfig.styles';
import TextField from '../../../../common/components/fields/TextField';

const IRTHConfig = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField className={classes.textField} name="irthConfig.apiUrl" placeholder={i18n.t('client.form.apiUrl')} />
        </Grid>
        <Grid item xs={6}>
          <TextField className={classes.textField} name="irthConfig.apiKey" placeholder={i18n.t('client.form.apiKey')} />
        </Grid>
        <Grid item xs={12}>
          <Field rows="5" className={classes.textArea} name="irthConfig.clientTemplate" as="textarea" placeholder={i18n.t('client.form.clientTemplate')} />
        </Grid>
      </Grid>
    </div>
  );
};

IRTHConfig.defaultProps = {};

export default IRTHConfig;
